import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import "firebase/auth";
import "firebase/firestore";
import firebase from "firebase/app";
import { sendMagicLink, loginUserByGoogle } from "../actions";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/styles";
import RectangularButton from "./Buttons/RectangularButton";
import babysitterLogo from "./images/babysitter-logo-adi.svg";
import googleLogo from "./images/google-logo.png";

const styles = () => ({
  background_style: {
    position: "absolute",
    left: "0%",
    right: "0%",
    top: "0%",
    bottom: "0%",
    background: "linear-gradient(212.27deg, #DBE9D6 -3.98%, #F6F7F9 108.26%)",
  },
  form: {
    marginTop: 20,
  },
  errorText: {
    color: "#f50057",
    marginBottom: 5,
    textAlign: "center",
  },
  button1: {
    fontFamily: "Open Sans Hebrew",
    background: "#65AC45",
    borderRadius: "4px",
    color: "white",
    // "width":"240px",
    // "height":"40px"
  },
  button2: {
    fontFamily: "Open Sans Hebrew",
    background: "#FFFFFF",
    border: "1px solid #C4C4C4",
    borderRadius: "4px",
    // "width":"240px",
    // "height":"40px"
  },
  introduction: {
    marginTop: 185,
    fontFamily: "Open Sans Hebrew",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "130%",
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    color: "#111617",
    opacity: "0.7",
  },
});


const babysitter_logo_style = {
  position: "absolute",
  width: "235px",
  height: "106px",
  top: "50px",
};

const top_logo_style = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-ends",
  justifyContent: "flex-end",
};

const bottom_logo_style = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};

const text_style = {
  fontFamily: "Open Sans Hebrew",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: "16px",
  color: "#111617",
  "text-align": "center",
  opacity: "0.7",
};

const buttons_div_style = {
  margin: "auto",
  width: "75%",
};

const provider = new firebase.auth.GoogleAuthProvider();

class Login extends Component {
  state = { email: "" };

  handleEmailChange = ({ target }) => {
    this.setState({ email: target.value });
  };

  magicLink = () => {
    const { dispatch } = this.props;
    const { email } = this.state;
    dispatch(sendMagicLink(email));
  };

  googleButton = () => {
    const { dispatch } = this.props;
    dispatch(loginUserByGoogle(provider));
  };

  render() {
    const { classes, loginError, emailsent, isAuthenticated } = this.props;
    if (isAuthenticated) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className={classes.background_style}>
          <Container component="main" maxWidth="xs">
            <div style={bottom_logo_style}>
              <img src={babysitterLogo} style={babysitter_logo_style} />
            </div>
            <Box m={10} />
            <div className={classes.introduction}>
              ברוכים הבאים, יש להזין את כתובת המייל באמצעותה התבצע הרישום על מנת
              לקבל קישור להתחברות לאתר.
            </div>
            <Box m={3} />
            <div dir="ltr">
              <TextField
                inputProps={{ style: { textAlignLast: "left" } }}
                multiline
                fullWidth
                id="email"
                label="הכנס כתובת מייל"
                name="email"
                onChange={this.handleEmailChange}
              />
            </div>
            {loginError && (
              <Typography component="p" className={classes.errorText}>
                כתובת מייל או סיסמה שגויה
              </Typography>
            )}
            <Box m={3} />
            <div style={buttons_div_style}>
              <Button
                type="button"
                fullWidth
                className={classes.button1}
                variant="contained"
                onClick={this.magicLink}
              >
                כניסה
              </Button>
              <p style={text_style}>-או-</p>
              <Button
                type="button"
                fullWidth
                variant="contained"
                className={classes.button2}
                onClick={this.googleButton}
              >
                <img src={googleLogo} />
                <Box m={0.7} />
                כניסה באמצעות חשבון גוגל
              </Button>
              <Box m={4.5} />
              <RectangularButton
                link="/signup"
                text="עדיין לא נרשמת? לחץ כאן "
              />
              {/*
              <Box m={4.5} />
              <RectangularButton link="/landingPage" text="דף נחיתה" />
            */}
            </div>
          </Container>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    isLoggingIn: state.auth.isLoggingIn,
    loginError: state.auth.loginError,
    isAuthenticated: state.auth.isAuthenticated,
    emailsent: state.auth.emailsent,
  };
}

export default withStyles(styles)(connect(mapStateToProps)(Login));
